import { render, staticRenderFns } from "./anli.vue?vue&type=template&id=2232af4d&scoped=true&"
import script from "./anli.vue?vue&type=script&lang=js&"
export * from "./anli.vue?vue&type=script&lang=js&"
import style0 from "./anli.vue?vue&type=style&index=0&id=2232af4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2232af4d",
  null
  
)

export default component.exports